import { useContext, useEffect, useRef, useState } from "react"
import { baseURL, path } from "../constants"
import { appContext } from "../Context/appContext"
import { api } from "../helpers"
import Loader from "./Loader"
import Select from 'react-select'
import {Trash} from 'react-feather'

export const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '50px', 
      height: '50px',  
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: '50px',
      padding: '0 8px', 
    })
}

export default function AddTenant(){
    const {toggleATenant, showAddTenant, showMessage, setImageControl} = useContext(appContext)
    const [loading, setLoading] = useState(false)
    const shortRef = useRef(), longRef = useRef(), hqRef = useRef(), billingRef = useRef(),
    phoneRef = useRef(), repRef = useRef(), repPhoneRef = useRef(), planRef = useRef()
    const [logo, setLogo] = useState(null)

    const planOptions = [
        {label: 'Premium', value: 'premium'}
    ]
    const [plan, setPlan] = useState(planOptions[0])

    const categoryOptions = [
        {label: 'Wedding Venue', value: 'wedding-venue'},
        {label: 'Catering Services', value: 'catering-services'},
        {label: 'Wedding Planners', value: 'wedding-planners'},
        {label: 'Event Coordinators', value: 'event-coordinators'},
        {label: 'Photography and Videography', value: 'photography-and-videography'},
        {label: 'Floral-Design', value: 'floral-design'},
        {label: 'Decor and Rentals', value: 'decor-and-rentals'},
        {label: 'Entertainment Services', value: 'entertainment-services'},
        {label: 'Transportation Services', value: 'transportation-services'},
        {label: 'Wedding Attire', value: 'wedding-sttire'},
        {label: 'Beauty Services', value: 'beauty-services'},
        {label: 'Honeymoon and Travel Services', value: 'honeymoon-and-travel-services'},
        {label: 'Guest Services', value: 'guest-services'},
    ]
    const [category, setCategory] = useState(categoryOptions[0])

    const billingOptions = [
        {label: 'Monthly', value: 'monthly'},
        {label: 'Quarterly', value: 'quarterly'},
        {label: 'Yearly', value: 'yearly'}
    ]

    const [billing, setBilling] = useState(billingOptions[0])

    const addOrEditVendor = (e) => {
        e.preventDefault()
        setLoading(true)
        api[showAddTenant.data ? 'patch' : 'post'](path.tenant, {
            short_name: e.target.short_name.value,
            long_name: e.target.long_name.value,
            category:  e.target.category.value,
            headquarter: e.target.headquarter.value,
            phone_number: e.target.phone_number.value,
            rep_name: e.target.rep_name.value,
            rep_phone: e.target.rep_phone.value,
            plan: e.target.plan.value,
            billing_cycle: e.target.billing_cycle.value,
            logo: logo?.path,
            id: showAddTenant.data?.id
        }).then(response => {
            if(response.data.success) {
                toggleATenant()
                showMessage(`Tenant successfully ${showAddTenant.data ? 'updated' : 'created'}!`, false)
            }
            else showMessage('Error has been occured!', true)
        })
        .catch(e => showMessage('Error has been occured!', true))
        .finally(() => setLoading(false))

    }

    useEffect(() => {
        if(showAddTenant.data){
            let data = showAddTenant.data
            if(shortRef.current) shortRef.current.value = data?.short_name || ''
            if(longRef.current) longRef.current.value = data?.long_name || ''
            if(phoneRef.current) phoneRef.current.value = data?.phone_number || ''
            setPlan(planOptions.find(p => p.value == data.plan))
            setBilling(billingOptions.find(p => p.value == data.billing_cycle))
            setCategory(categoryOptions.find(p => p.value == data.category))
            if(repRef.current) repRef.current.value = data?.rep_name || ''
            if(repPhoneRef.current) repPhoneRef.current.value = data?.rep_phone || ''
            if(hqRef.current) hqRef.current.value = data?.headquarter || ''
        }
    }, [showAddTenant])

    if(!showAddTenant.visible) return null
    return (
        <div className='fixed inset-0 flex items-center justify-center bg-[#00000080] z-[99999]'>
            <form method="post" onSubmit={addOrEditVendor} className='flex flex-col gap-4 p-4 bg-white p-6 rounded-md'>
                <h2 className="self-center text-[25px] font-bold ">{showAddTenant.data ? 'Edit Vendor' : 'Create New Tenant'}</h2>
                <div className='grid grid-cols-3 gap-6 feel-c1 bg-[#00000010] p-4'>
                    <div className='flex flex-col gap-2'>
                        <p>Short Name</p>
                        <input placeholder='Short Name' ref={shortRef} name="short_name" className='input' type='text' required/>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <p>Long Name</p>
                        <input placeholder='Long Name' ref={longRef} name="long_name" className='input' type='text' required/>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <p>Business Category</p>
                        <Select onChange={setCategory} options={categoryOptions} value={category} styles={customStyles} name="category" required />
                    </div>
                    <div className='flex flex-col gap-2'>
                        <p>Headquarter</p>
                        <input placeholder='HQ Address' ref={hqRef} name="headquarter" className='input' type='text' required/>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <p>Phone Number</p>
                        <input placeholder='Office Phone' ref={phoneRef} name="phone_number" className='input' type='text' required/>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <p>Rep. Name</p>
                        <input placeholder='Rep. Name' ref={repRef} name="rep_name" className='input' type='text' required/>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <p>Rep. Phone</p>
                        <input placeholder='Rep. Phone' ref={repPhoneRef} name="rep_phone" className='input' type='text' required/>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <p>Plan</p>
                        <Select onChange={setPlan} options={planOptions} value={plan} styles={customStyles} name="plan" required  />
                    </div>
                    <div className='flex flex-col gap-2'>
                        <p>Billing Cycle</p>
                        <Select onChange={setBilling} options={billingOptions} value={billing} styles={customStyles} name="billing_cycle" required />
                    </div>
                    <div className='flex flex-col gap-2'>
                        <p>Compnay Logo</p>
                        <div className='flex items-center gap-2 flex-1'>
                            {logo?.path && <>
                                <img onClick={e => window.open(e.target.src, '_blank')} style={{width: '40px', height: '40px', objectFit: 'contain'}} src={URL.createObjectURL(logo.blob)} />
                                <button onClick={() => setLogo(null)}><Trash color='#ff0000' size={15} /></button>
                            </>}
                            <button type='button' onClick={() => setImageControl({visible: true, setImage: setLogo})} className='py-2 px-8 font-bold text-[16px] bg-black text-white self-center w-full'>Select Image</button>
                        </div>
                    </div>
                </div>
                <div className='flex justify-center gap-6'>
                    <button type="submit" className='py-2 px-8 font-bold text-[20px] bg-main text-white self-center' type='submit'>
                        <Loader text={showAddTenant.data ? 'Update' : 'Create Tenant'} loading={loading} />                        
                    </button>
                    <button onClick={() => toggleATenant()} className='py-2 px-8 font-bold text-[20px] border-main border-[2px] text-black self-center' type='submit'>Cancel</button>
                </div>
            </form>
        </div>
    )
}